<template>
    <v-container fluid>
        <slot></slot>
    </v-container>
  </template>
  
  <script>

import store from '@/store'
import { onUnmounted } from '@vue/composition-api'
import oculisStoreModule from './oculisStoreModule'

  export default {
    setup() {

        const OCULIS_APP_STORE_MODULE_NAME = 'app-oculis'
        // Register module
        if (!store.hasModule(OCULIS_APP_STORE_MODULE_NAME)) store.registerModule(OCULIS_APP_STORE_MODULE_NAME, oculisStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
        if (store.hasModule(OCULIS_APP_STORE_MODULE_NAME)) store.unregisterModule(OCULIS_APP_STORE_MODULE_NAME)
        })

    }
  };
  </script>